import { FC } from 'react';

import AdminDashboard from '@/pages/AdminDashboard';

const HomePage: FC = () => {
  return <AdminDashboard />;
};

export default HomePage;
